import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';

import { InputField, Input, ToggleField, Toggle, AutoCompleteField, AutoComplete } from '@components/form';
import { jobTypeEnum } from '@modules/jobs/_jobsEnums';

export const JobsFormBasic = ({ change }) => (
  <Grid fluid={true}>
    <Row>
      <Col className="grid-system-margin" />
    </Row>
    <Row>
      <Col md={6} className="with-right-divider">
        <Col md={12}>
          <InputField component={Input} name="name" label="Název" />
        </Col>
        <Col md={12}>
          <InputField component={Input} name="timing" label="Čas spuštení (Cron)" />
        </Col>
      </Col>
      <Col md={6}>
        <Col md={12}>
          <InputField component={Input} name="script" label="Skript" />
        </Col>
        <Col md={12}>
          <AutoCompleteField
            component={AutoComplete}
            name="scriptType"
            label="Typ Skriptu"
            items={jobTypeEnum}
            labelFunction={o => get(o, 'label')}
            valueFunction={o => get(o, 'id')}
          />
        </Col>
        <Col md={12}>
          <ToggleField
            component={Toggle}
            name="active"
            label="Aktivní"
            labelPosition="right"
            onToggle={(_, value) => {
              change('active', value);
            }}
            style={{ margin: '10px 0' }}
          />
        </Col>
      </Col>
    </Row>
  </Grid>
);



// WEBPACK FOOTER //
// ./src/modules/jobs/JobsFormBasic.tsx